// extracted by mini-css-extract-plugin
export var auto = "_y-1";
export var spinner = "_y-0";